import { useFormik } from 'formik';
import { Button, Divider, TextField, Typography } from '@mui/material';

import validationSchemas from 'utils/validationSchemas';
import { ActionButtons } from 'components';

const ProfileEditForm = ({ user, onSubmit, onCancel }) => {
	const formik = useFormik({
		initialValues: {
			name: user.name,
			lastName: user.lastName,
			email: user.email,
			phone: user.phone || '',
			password: '',
			confirmPassword: '',
		},
		validationSchema: validationSchemas.profile,
		onSubmit,
	});

	return (
		<div className="ProfileEditForm">
			<form onSubmit={formik.handleSubmit}>
				<TextField
					fullWidth
					id="lastName"
					name="lastName"
					label="Apellidos"
					value={formik.values.lastName}
					onChange={formik.handleChange}
					error={formik.touched.lastName && Boolean(formik.errors.lastName)}
					helperText={formik.touched.lastName && formik.errors.lastName}
					margin="normal"
				/>
				<TextField
					fullWidth
					id="name"
					name="name"
					label="Nombres"
					value={formik.values.name}
					onChange={formik.handleChange}
					error={formik.touched.name && Boolean(formik.errors.name)}
					helperText={formik.touched.name && formik.errors.name}
					margin="normal"
				/>
				<TextField
					fullWidth
					id="email"
					name="email"
					label="Correo electrónico"
					value={formik.values.email}
					onChange={formik.handleChange}
					error={formik.touched.email && Boolean(formik.errors.email)}
					helperText={
						(formik.touched.email && formik.errors.email) ||
						(user.role !== 'ADMIN' && 'Para cambiar tu email, contacta a un administrador')
					}
					margin="normal"
					disabled={user.role !== 'ADMIN'}
				/>
				<TextField
					fullWidth
					id="phone"
					name="phone"
					label="Teléfono celular"
					value={formik.values.phone}
					onChange={formik.handleChange}
					error={formik.touched.phone && Boolean(formik.errors.phone)}
					helperText={formik.touched.phone && formik.errors.phone}
					margin="normal"
				/>
				<Divider sx={{ my: 1 }} />
				<Typography variant="body2">
					Para cambiar tu contraseña, escribe y confirma una nueva:
				</Typography>
				<TextField
					fullWidth
					id="password"
					name="password"
					label="Contraseña"
					type="password"
					value={formik.values.password}
					onChange={formik.handleChange}
					error={formik.touched.password && Boolean(formik.errors.password)}
					helperText={formik.touched.password && formik.errors.password}
					margin="normal"
				/>
				<TextField
					fullWidth
					id="confirmPassword"
					name="confirmPassword"
					label="Confirma tu contraseña"
					type="password"
					value={formik.values.confirmPassword}
					onChange={formik.handleChange}
					error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
					helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
					margin="normal"
				/>
				<ActionButtons style={{ marginTop: 8 }}>
					<Button onClick={onCancel}>Cerrar</Button>
					<Button variant="contained" type="submit">
						Guardar
					</Button>
				</ActionButtons>
			</form>
		</div>
	);
};

export default ProfileEditForm;
